import React from "react";

export const CatalogIconGray = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 10H5.5C4.94772 10 4.5 10.4477 4.5 11V18C4.5 18.5523 4.94772 19 5.5 19H19.5C20.0523 19 20.5 18.5523 20.5 18V11C20.5 10.4477 20.0523 10 19.5 10Z"
        stroke="#E9EBF0"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.5H18.5"
        stroke="#E9EBF0"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 5H16.5"
        stroke="#E9EBF0"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
